import React__default from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { DefaultCustomResourceDrawer } from './DefaultCustomResourceDrawer.esm.js';
import { StructuredMetadataTable } from '@backstage/core-components';

const DefaultCustomResourceSummary = ({
  customResource,
  customResourceName
}) => {
  return /* @__PURE__ */ React__default.createElement(
    Grid,
    {
      container: true,
      direction: "row",
      justifyContent: "space-between",
      alignItems: "center",
      spacing: 0
    },
    /* @__PURE__ */ React__default.createElement(Grid, { xs: 12, item: true }, /* @__PURE__ */ React__default.createElement(
      DefaultCustomResourceDrawer,
      {
        customResource,
        customResourceName
      }
    ))
  );
};
const DefaultCustomResourceAccordion = ({
  customResource,
  customResourceName,
  defaultExpanded
}) => {
  return /* @__PURE__ */ React__default.createElement(
    Accordion,
    {
      defaultExpanded,
      TransitionProps: { unmountOnExit: true },
      variant: "outlined"
    },
    /* @__PURE__ */ React__default.createElement(AccordionSummary, { expandIcon: /* @__PURE__ */ React__default.createElement(ExpandMoreIcon, null) }, /* @__PURE__ */ React__default.createElement(
      DefaultCustomResourceSummary,
      {
        customResource,
        customResourceName
      }
    )),
    /* @__PURE__ */ React__default.createElement(AccordionDetails, null, Object.prototype.hasOwnProperty.call(customResource, "status") && /* @__PURE__ */ React__default.createElement(StructuredMetadataTable, { metadata: customResource.status }))
  );
};
const DefaultCustomResourceAccordions = ({
  customResources,
  customResourceName,
  defaultExpanded = false
}) => {
  return /* @__PURE__ */ React__default.createElement(
    Grid,
    {
      container: true,
      direction: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start"
    },
    customResources.map((cr, i) => /* @__PURE__ */ React__default.createElement(Grid, { container: true, item: true, key: i, xs: true }, /* @__PURE__ */ React__default.createElement(Grid, { item: true, xs: true }, /* @__PURE__ */ React__default.createElement(
      DefaultCustomResourceAccordion,
      {
        defaultExpanded,
        customResource: cr,
        customResourceName
      }
    ))))
  );
};

export { DefaultCustomResourceAccordions };
//# sourceMappingURL=DefaultCustomResource.esm.js.map
